import { useContext } from "react";
import NotificationContext from "../context/NotificationContext";
import { formatClassTime } from "../utils/classTimeUtils";
import TeacherPhoto from "./TeacherPhoto";

function RegistrationDialogModal(props) {
  const notificationCtx = useContext(NotificationContext);

  return (
    <div
      className="modal show"
      style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.5)",
      }}
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-bs-backdrop="true"
      data-bs-keyboard="true"
    >
      <div
        className="modal-dialog modal-lg"
        style={{
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          className="modal-content"
          style={{
            flexGrow: 1,
            backgroundColor: "#ffffff",
            borderRadius: "15px",
            padding: "0 20px",
          }}
        >
          <div className="modal-header">
            <h5 className="modal-title text-center">Courses Registration</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => props.setShowForm(false)}
              aria-label="Close"
            ></button>
          </div>
          <div
            className="modal-body"
            style={{
              overflowY: "auto",
              maxHeight: "80vh",
            }}
          >
            <div
              className="form-group"
              style={{
                margin: "auto",
                padding: "20px",
                border: "1px solid #ffffff",
                borderRadius: "10px",
              }}
            >
              <div className="mb-3">
                <h5>Selected Courses: </h5>
                {props.courses.map((course) => {
                  return (
                    <div>
                      <h6>{course.title}</h6>
                    </div>
                  );
                })}
              </div>
              <div className="mb-3">
                <p>
                  <strong>Student ID: </strong>
                  {props.userId}
                </p>
              </div>
              <div className="mb-3">
                <p>
                  <strong>Name: </strong>
                  {props.name}
                </p>
              </div>
              <div className="mb-3">
                <p>
                  <strong>Phone No: </strong>
                  {props.phone}
                </p>
              </div>
              <div className="mb-3">
                <select
                  id="feemode"
                  name="feemode"
                  value={props.feemode}
                  onChange={(e) => {
                    props.setfeemode(e.target.value);
                  }}
                  required
                  disabled={
                    props.selectedfeemode !== "" &&
                    props.selectedfeemode !== null
                  } // disable if mode is already selected or null
                  style={{
                    padding: "10px",
                    borderRadius: "5px",
                    width: "100%",
                    backgroundColor: "#ffffff",
                  }}
                >
                  {props.selectedfeemode !== "" ? (
                    (props.setfeemode(props.selectedfeemode),
                    (
                      <option value={props.selectedfeemode}>
                        {props.selectedfeemode === "full"
                          ? "Full Payment"
                          : "Partial Payment (Financial Aid)"}
                      </option>
                    ))
                  ) : (
                    <>
                      <option value="" disabled>
                        Select Fee Mode
                      </option>
                      <option value="full">Full Payment</option>
                      <option value="partial">
                        Partial Payment (Financial Aid)
                      </option>
                    </>
                  )}
                </select>
              </div>

              {/* <div className="map-container mt-3">
                          {coords ? (
                            <>
                              <p>Your Location:</p>
                              <MapContainer
                                center={[coords.latitude, coords.longitude]}
                                zoom={16}
                                style={{ height: "300px", width: "100%" }}
                              >
                                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                <Marker
                                  position={[coords.latitude, coords.longitude]}
                                >
                                  <Popup>You are here!</Popup>
                                </Marker>
                              </MapContainer>
                            </>
                          ) : (
                            <p>Loading your location...</p>
                          )}
                        </div> */}
              <button
                type="button"
                disabled={props.registering}
                onClick={
                  props.feemode === "partial"
                    ? props.checkFinancialAidRecord
                    : props.feemode === "full"
                    ? props.registerCourse
                    : () => {
                        notificationCtx.show({
                          message: "Please select a fee mode to proceed.",
                        });
                      }
                }
                style={{
                  backgroundColor: "#d5d1fd",
                  borderColor: "#d5d1fd",
                }}
              >
                {props.registering ? "Working..." : "Register"}
              </button>
            </div>
            {props.suggestions.length > 0 && (
              <h5 className="mt-3">Popular with your courses</h5>
            )}
            <div className="row">
              {props.suggestions.map((course) => {
                return (
                  <div
                    key={course.id}
                    className="col-md-12 my-2"
                    style={{ padding: "0 20px" }}
                  >
                    <div
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "10px",
                        padding: "20px",
                        textAlign: "center",
                        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                      }}
                      className="row"
                    >
                      <div className="col-md-4">
                        <TeacherPhoto
                          picture={course.Teacher?.picture}
                          name={course.Teacher?.name}
                          variant="portrait"
                          style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "15px",
                          }}
                        />
                      </div>

                      <div className="col-md-8">
                        <h3>{course.title.toUpperCase()}</h3>
                        <h6
                          style={{
                            backgroundColor: "#bff1db",
                            padding: "5px 10px",
                            borderRadius: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          {course.teacher.toUpperCase()}
                        </h6>

                        <p
                          style={{
                            backgroundColor: "#f9e1be",
                            padding: "5px 10px",
                            borderRadius: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          {course.id}
                        </p>
                        <p
                          style={{
                            backgroundColor: "#f2c4c4",
                            padding: "5px 10px",
                            borderRadius: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          {formatClassTime(course.classTime) }
                        </p>
                      </div>
                      <button
                        className="btn btn-primary mt-2"
                        onClick={props.selectCourse(course)}
                        style={{
                          backgroundColor: props.selectedCourseIds.includes(
                            course.id
                          )
                            ? "#d5d1fd" // different shade for selected
                            : "#d5d1fd",
                          borderColor: "#d5d1fd",
                        }}
                      >
                        {props.selectedCourseIds.includes(course.id)
                          ? "Selected"
                          : "Select"}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegistrationDialogModal;
